<template>
  <div class="chat-input">
    <div class="ui fluid action input chat-input-box">
      <input
        type="text"
        v-model="inputText"
        :placeholder="placeholder"
        @keyup.enter="handleSend"
        :disabled="disabled"
        maxlength="1000"
      >
      <button
        class="ui blue button"
        @click="handleSend"
        :disabled="disabled || !inputText.trim()"
      >
        <i class="paper plane icon"></i>发送
      </button>
    </div>
    <div class="input-hint">
      <span>按 Enter 发送，最多 1000 字符</span>
      <span v-if="inputText.length > 0" class="char-count">{{ inputText.length }}/1000</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatInput',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '输入你的问题...'
    }
  },
  data() {
    return {
      inputText: ''
    }
  },
  methods: {
    handleSend() {
      const text = this.inputText.trim()
      if (!text || this.disabled) return
      this.$emit('send', text)
      this.inputText = ''
    }
  }
}
</script>

<style scoped>
.chat-input {
  padding: 16px 40px;
  border-top: 1px solid #e8e8e8;
  background: white;
}

.chat-input-box {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.chat-input-box input {
  font-size: 14px;
  padding: 12px 16px;
  border: 1px solid #e8e8e8;
  border-right: none;
}

.chat-input-box input:focus {
  border-color: #48dbfb;
  outline: none;
}

.chat-input-box .ui.blue.button {
  border-radius: 0;
  padding: 0 20px;
  font-size: 14px;
  white-space: nowrap;
}

.input-hint {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-size: 12px;
  color: #bbb;
  padding: 0 4px;
}

.char-count {
  color: #999;
}
</style>
